import { FontSize, LineHeight, Textarea as TextareaComponent } from '@billy/design-system'
import styled from '@emotion/styled'

export const HeaderWrapper = styled.header`
  display: flex;
  align-items: center;
`

export const Textarea = styled(TextareaComponent)`
  font-size: ${FontSize.TextBodySM};
  line-height: ${LineHeight.TextBodySM};
`
